import { Text, TextInput, Div } from '@tblabs/truffle';
import { Page } from '../Page';
import { CenteredRow, LeftAlignedRow, Row } from '../../Components/General/Row';
import { Translations } from '../../Translations/Translations';
import { PrimaryButton } from '../../Components/General/Buttons/PrimaryButton';
import { HelpButton } from '../../Components/Buttons/HelpButton';
import { AppConfigProvider } from '../../Services/AppConfigProvider';
import { ServerSelector } from '../../Components/ServerSelector';
import { LanguageSelector } from './LanguageSelector';
import { DefaultButton } from '../../Components/General/Buttons/DefaultButton';
import { LoginLogic } from '../../Logic/LoginLogic';


export class LoginPage extends Page
{
    private readonly passwordInput: TextInput;
    private readonly loginButton: PrimaryButton;
    private statusBox = new Div().Class("uk-alert-warning uk-margin-small warning")

    constructor(
        private _logic: LoginLogic,
        private _lang: Translations,
        private _config: AppConfigProvider)
    {
        super(_lang.LoginPageTitle)
        this.Class("LoginPage")

        this.statusBox
            .Append(new Text(this._logic.ErrorMessage))
            .Visible(this._logic.ErrorMessageVisible)

        this.loginButton = new PrimaryButton(this._lang.LoginButton).Class("btn half")
            .OnClick(async () => await this._logic.TryLogin())

        this.passwordInput = new TextInput(this._logic.PasswordInput).MarginBottom(0).Class("uk-margin-small")
            .Placeholder(this._lang.CharactersSizeAreNotImportant)
            .OnEnterKeyPressed(async () => await this._logic.TryLogin())

        const openDemoButton = new DefaultButton("Demo").Class("btn half").Background("#f6f6f6")
            .OnClick(() => window.location.href = "#watch/demo")


        this.AddToHeader(
            new Div().Text(_lang.LoginPageTitle.value).Class("device-id"),
            new Div("header-menu-box").Append(
                new HelpButton(_lang),
            )
        );

        this.AddToBody(
            new CenteredRow(new LanguageSelector(_lang).MarginBottom(48).MarginTop(32).Width(194)),
            new LeftAlignedRow(
                new Text(_lang.Password).Class("uk-text-primary uk-margin-small")
            ),
            new Row(this.passwordInput),
            new Row(
                openDemoButton,
                this.loginButton,
            ).Class("buttons"),
            new Row(this.statusBox).MarginTop(16),
            new CenteredRow(
                new ServerSelector(this._config)
            ).PositionAbsolute().Bottom(52).Left(0),
        );
    }
}
